<table>
  <ng-content *ngIf="cabecalhoCustomizado; else cabecalhoPadrao" select="[cabecalho]"></ng-content>
  <ng-template #cabecalhoPadrao>
    <tr class="cabecalho">
      <th
        *ngFor="let tituloDaColuna of cabecalhos"
        [innerHTML]="tituloDaColuna.titulo"
        [attr.rowspan]="tituloDaColuna.subtitulos ? null : 2"
        [attr.colspan]="tituloDaColuna.subtitulos ? tituloDaColuna.subtitulos.length : null"
        [ngStyle]="{ width: tituloDaColuna.tamanho }"
      >
        {{ tituloDaColuna.titulo }}
      </th>
    </tr>
    <tr class="cabecalho-subtitulo">
      <th *ngFor="let subtitulo of subtitulos()" [innerHTML]="subtitulo" ></th>
    </tr>
  </ng-template>
  <ng-content select="[corpo]"></ng-content>
  <ng-content select="[rodape]"></ng-content>
</table>
